import {InjectionToken} from '@angular/core';

export const GRID_FILTER_RULES = new InjectionToken<Record<string, any>>('GRID_FILTER_RULES');
